import api from '../utils/axiosConfig'
import type {
  PaginatedPaymentOrderListResponse,
  PaymentOrderDetail,
  PaymentOrderQueryParams,
  PaymentProviderQueryResponse,
} from '../types/payment'

export const getPaymentOrderList = async (
  params: PaymentOrderQueryParams = {}
): Promise<PaginatedPaymentOrderListResponse> => {
  const response = await api.get<PaginatedPaymentOrderListResponse>(
    '/payments/orders',
    {
      params,
    }
  )
  return response.data
}

export const getPaymentOrderDetail = async (
  businessOrderNo: string
): Promise<PaymentOrderDetail> => {
  const response = await api.get<PaymentOrderDetail>(
    `/payments/orders/${businessOrderNo}`
  )
  return response.data
}

export const queryPaymentAttempt = async (
  attemptNo: string
): Promise<PaymentProviderQueryResponse> => {
  const response = await api.post<PaymentProviderQueryResponse>(
    `/payments/attempts/${attemptNo}/query`
  )
  return response.data
}

export const queryPaymentRefund = async (
  refundOrderNo: string
): Promise<PaymentProviderQueryResponse> => {
  const response = await api.post<PaymentProviderQueryResponse>(
    `/payments/refunds/${refundOrderNo}/query`
  )
  return response.data
}
